module.exports = __webpack_public_path__ + "staticcomp/img/content_1副本.79e6992.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/3/content_1副本.jpg
// module id = Yea/
// module chunks = 39